<template>
  <div class="buy-content">
    <h5>{{goods.name}}</h5>
    <ul>
      <li>
        <h4>商品价格</h4>
        <h3>{{goods.goodsDetail.marketPrice}}智豆</h3>
      </li>
      <!-- <li>
              <h4>优惠</h4>
              <h3>已使用优惠券<span>50智豆</span> <img class="arrow-icon" src="/images/arrow_icon.png" alt="" @click="$router.push({path:`/goods/coupon`, query:{goodsNum:$route.query.goodsNum}})"></h3>
            </li> -->
      <li>
        <h4>还需支付</h4>
        <h3><span>{{finalPrice}}智豆</span></h3>
      </li>
    </ul>
    <button @click="handelButton">智豆支付</button>
    <button>微信支付</button>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from "vuex";

  export default {
    props: {
      goods: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        userCoin: 0,
        isCoinEnough: false,
        finalPrice: 0,
        couponCode: 0
      }
    },
    created() {
      this.handelUserCoin()
    },
    methods: {
      ...mapMutations({
        setLoading: "setLoadingShow"
      }),
      //判断用户智豆数量是否足够
      handelUserCoin() {
        this.$api.payment_v1_pay_check_get({
          params: {
            total: this.finalPrice,
            uid: this.uid,
            goodsNum: this.goods.goodsDetail.goodsNum,
          }
        }).then(e => {
          if (e.code == 0) {
            this.isCoinEnough = false;
            this.userCoin = e.num;
            this.finalPrice = e.price;
          }
        })
      },
      handelButton() {
        if (!this.isCoinEnough) {
            
        } else {
          //智豆支付
          this.setLoading({
            show: true,
            text: "支付中"
          })
          this.$api.payment_v1_pay_zhiBeanPay_post({
            data: {
              //  couponCode: this.couponCode,
              goodsNum: this.goods.goodsDetail.goodsNum,
              total: this.finalPrice,
              uid: this.uid,
            }
          }).then(e => {
            this.setLoading({
              show: false
            })
            // if (res.err_msg == "get_brand_wcpay_request:ok") {
            //   _this.$store.commit('setToastShow', {
            //     show: true,
            //     content: {
            //       txt: '支付成功，如还未显示已开通装填，请刷新页面',
            //       type: 'txt'
            //     }
            //   })
            //   _this.$router.go(-1);
            // } else {
            //   _this.$store.commit('setToastShow', {
            //     show: true,
            //     content: {
            //       txt: '支付失败，请重试!',
            //       type: 'txt'
            //     }
            //   })
            // }
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        isPlusMember: "auth/isPlusMember",
        uid: "auth/uid",
        isNative: "externalInterface/isNative",
      }),
      // finalPrice() {
      //   return this.isPlusMember ? this.goods.goodsDetail.price : this.goods.goodsDetail.marketPrice;
      // },
      // buyButtonBg() {
      //   if (this.isCoinEnough) {
      //     return {
      //       color: "#3F8DFD",
      //       text: "立即支付",
      //     }
      //   } else {
      //     return {
      //       color: "#FF5B5A",
      //       text: "智豆余额不足，立即充值",
      //     };
      //   }
      // },
    }
  }
</script>


<style scoped>
  .buy-content {
    width: 100%;
    border-radius: 8px 8px 0 0;
    background-color: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
  }

  .buy-content {
    overflow: hidden;
  }

  .buy-content h5 {
    width: 100%;
    height: 56px;
    background: rgba(248, 248, 248, 1);
    font-size: 17px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 56px;
    text-align: center;
  }

  .buy-content ul {
    padding: 0 16px;
  }

  .buy-content ul li {
    height: 54px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .buy-content ul li+li {
    border-top: 1px solid #f4f4f4;
  }

  .buy-content h4 {
    height: 22px;
    font-size: 16px;
    font-weight: 500;
    color: rgba(79, 79, 79, 1);
    line-height: 22px;
  }

  .buy-content h3 {
    height: 22px;
    font-size: 16px;
    color: rgba(149, 149, 149, 1);
    line-height: 22px;
  }

  .buy-content h3 span {
    color: #4897fd;
  }

  .buy-content h3 .arrow-icon {
    width: 5px;
    height: 9px;
    margin-left: 9px;
  }

  .buy-content button {
    display: block;
    width: 309px;
    height: 42px;
    border-radius: 8px;
    margin: 14px auto 24px;
    font-size: 18px;
    color: #ffffff;
    line-height: 42px;
    background-color: #3F8DFD;
  }
</style>